module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('span', {
    staticClass: "Serif_Bold _idGenCharOverride-1"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("I")]), _vm._v("t had taken the be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" part of November "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r Danny to become convinced he really did have the kind of "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory he’d dreamed of. In his spare time, he’d poked around the newspaper cuttings library, searching "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r anything he could "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd on insurance "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("aud and tax evasion. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e bottom line he kept butting up again"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" was that nobody who’d made a pile wanted to pay the Labour government’s high taxes. But he couldn’t "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd anything dodgy in the cuttings that matched the PII prospectus. If he was going to get any "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("rther with this, he was going to have to do some sneaki"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ng around.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("And so, on the second Sunday in December, when he knew Joseph would be at Mass with his parents, he plucked up the courage to use the door key he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ill owned and let himself in. He went "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight to his brother’s bedroom and opened the wardrobe where he knew he’d "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd Joseph’s brie"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fc")]), _vm._v("ase, a black leather box with brushed aluminium trim along the edges of the lid and the base. It was a badge of pride and Joseph carried it with the same reverence a paratrooper would a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffo")]), _vm._v("rd his "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("SLR ri")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("And it was unlocked. Why would it not be? His parents would never dream of invading the sanctity of Joseph’s brie"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fc")]), _vm._v("ase. Danny "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("icked through the contents. A couple of the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("miliar PII brochures. A car magazine. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en, more promising, a slim black address book. Danny wished he had a spy camera like James Bond in "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("On Her Maje")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("y’s Secret Service.")]), _vm._v(" He’d come back to it if he had time, he decided, and try to copy some of the contact details. A couple of lea"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("ets "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om banks about their inve"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ment services. He’d almo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" given up hope of "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nding anything use"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l when he came across a single sheet of paper in Joseph’s ha"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ndwriting.")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_First"
  }, [_vm._v("Brian McGillivray – "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Jan – 100k")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_Middle"
  }, [_vm._v("Wilson Brodie – "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("Feb – 125k")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_Last"
  }, [_vm._v("Andrew Mutch – Ma"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("rch – 130k")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("It meant nothing to him, but it was something out of the ordinary. Something that didn’t "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("t with what he under"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ood of the world of whole li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" and endowment policies. Danny copied the li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" into his notebook. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en he looked up the names in the address book. Each one had a li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ing, complete with addresses and numbers "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r phone and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("x. He noted the details, then replaced everything as he had"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("und it.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He hurried "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at and headed "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a ca"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fé")]), _vm._v(" across "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om Haymarket Station, in the opposite direction to the chapel his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mily would shortly be leaving. He could kill the be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" part of an hour in there with a mug of tea and the Sunday papers. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at way, he’d arrive at the usual time with nobody any "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the wiser.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("At the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art of his shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" next morning, the newsdesk had sent Danny "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight out on a job with a photographer. A run out to Falkirk to interview a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mily whose car had been swallowed by a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("twenty")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ot")]), _vm._v(" sinkhole that had appeared overnight at the bottom of their driveway. ‘Fucking wild,’ the photographer had said. ‘I’m not parking anywhere near the"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ir house.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("In the end, it had been by the numbers. My"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ery sinkhole, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mily wake to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd their car "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("oating in a wee lake of sewage, everybody bewildered, water board re"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("sing to accept any responsibility. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey were back to Glasgow in time to make it to the pub "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a quick pie and a pint be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re anyone noticed they’d been away"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" too long.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny seized the moment to buttonhole Peter McGovern who was, as usual, drinking alone behind the pink barrier of the "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Financial Times")]), _vm._v(". ‘Do these names mean anything to you?’ he said without preamble. He rattled them o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v("; McGovern’s eyebrows rose progressive"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ly higher.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Why do"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" you ask?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I got sight of a piece of paper my source didn’t want me to see. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ese are the nam"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("es on it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Intere"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ing.’ McGovern went through his routine with the Ca"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fé")]), _vm._v(" Crème and the Dunhill. ‘Brian McGillivray is the man behind We"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("Bet. He owns somewhere in the order of "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rty betting shops and he’s a presence on the racecourses too. Wilson Brodie has a chain of seaside amusement arcades on the Co"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("a del Clyde. You know the sort of thing – bingo, slot machines, pinball. And those da"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" crane claw machines where you never manage to grab anything worth having. Andrew Mutch is a builder. He specialises in local council contracts – schools, old people’s homes, o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ces. Do you see anything in comm"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("on there?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("owned. ‘McGillivray and Brodie, their businesses are all cash. So, they can lie about their incomings and cheat the taxman. But if Mutch is doing council work, that’ll all be done with invoices and payments "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight into the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("bank, no?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘You’re in the right area of the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(". Mutch could easily be laying his hands on large sums of cash. Say your project requires a hundred grand of materials. You buy them legitimately, you sell them "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r cash at a discount then you buy in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rior materials with some of that cash. And hey pre"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("o, you’ve got a pot of untraceable ready money. And that’s what these three guys have in common. "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("High")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("pro")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("le")]), _vm._v(", respectable businessmen looking "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a way to weasel out of their tax liabilities. Any notion of how they’re "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("doing it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny shook his head. ‘But I think we’re talking big money. Between a hundred and a hundred and thir"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ty grand.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("McGovern paused with his cigarillo hal"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fw")]), _vm._v("ay to his mouth. ‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at’ll be some "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory if you can bottom it. So,"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" can you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny sank the la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" of his pint of heavy. ‘I wouldn’t be here if I didn’t think I could.’ He wished he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt as con"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("dent as he sounded. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e truth was, all he had was a very "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("long shot.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("A"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er his conversation with McGovern, Danny had pondered his next move. It was possible that drink might loosen Joseph’s tongue at the various "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("mily parties over the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fest")]), _vm._v("ive season, but Danny couldn’t rely on that, and besides, he didn’t want to set any alarm bells ringing. His brother had never been inclined to provide details of the li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" he led outside the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("ur walls of his parents’ "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at; he much pre"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rred the sort of oblique hints that made him sound intriguing and important. When pressed, he would never let himself be pinned down. Danny didn’t even know if he had a girl"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("iend to show o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" in the passenger seat of his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("ashy red Tr"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("iumph TR7.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("If Danny was going to dig up anything solid, he was going to have to take a risk and go to the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("untainhead. But he’d have to pick his moment to avoid "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("irring any suspicion in his brother. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at year, Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas Eve "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("ll on a Sunday, which meant there would be an even longer Mass than usual in the morning "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("arters, with Midnight Mass to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("l"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("low later.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny laid his plans care"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("lly. He phoned his mother late on Saturday a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("ernoon and explained he was having to work on Sunday morning to cover "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a colleague whose daughter had been rushed to hospital. A wee tug on the heart"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rings always did the trick where Marie Sullivan was "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("concerned.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Early on the morning of Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas Eve, he drove to Edinburgh, revelling in the empty roads, and parked down the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("reet "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om his parents’ "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at. His Ford Escort was nondescript – he’d chosen it precisely because it would be unobtrusive on the "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ake")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("outs")]), _vm._v(" he dreamed of doing – and he slid down on the seat so he was barely visible. He waited "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" part of an hour, growing progressively colder, hoping the odd "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("urry of snow wouldn’t obscure"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" his view.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("But "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nally the three Sullivans emerged, scarved and gloved, collars raised, and set o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" briskly towards the chapel. Danny gave it "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve minutes in case any of them had "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rgotten something crucial, then he let himself into the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at, revelling "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a moment in the warmth be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re going through to Joseph’s room. He went "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight to the drawer in the bedside table, hoping that was "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ill where his brother "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ashed his keys. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was the TR7’s on its leather "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("b, next to the key to the outside door of the close and the pair that unlocked the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at itself. And underneath them, another bunch. Two Yales, a mortice and a pair of small keys that looked as if they’d "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("t a desk or a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("lin"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("g cabinet.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Ya beauty,’ Danny murmured, pocketing"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" the keys.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("Half an hour later, he was walking down the alley that ran alongside Paragon’s building, trying to look nonchalant. When he’d been promoted to having his own o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce two years be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re, Joseph hadn’t been able to resi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" showing o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" to his wee brother. ‘I bet you’ll never have an o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce like this,’ he’d boa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ed, walking Danny up to the third "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("oor and unlocking his door with a"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ourish.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("In spite of himself, Danny had been impressed. OK, the room was pretty small and it looked out on the alley, but it had dark wood panelling to wai"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" height and a big "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("amed print of a sailboat on one wall. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e desk was veneered "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("breboard, like the one Danny sat at every day. But Joseph had a big wooden chair with a carved back and arms, whereas the "), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("Clarion")]), _vm._v(" reporters hunched over their typewriters in badly adju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ed battered secretarial ones. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere were two visitors’ chairs uphol"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ered in dark tweed and a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ling cabinet in the corner behind the desk. Two telephones sat on the desk on either side of a leather blotter. He’d muttered something vaguely complimentary and made his escape as quickly as he could, knowing his parents had already had the tour of the o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce that Joseph would somehow have turned into a vehicle "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r them all pitying p"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("oor Danny.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Today, though, he was planning on turning the tables. If he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("und what he was looking "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r – even though he didn’t know what he was looking "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r – it would be a Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas present that would shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" the balance between the brothers"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("r ever.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny let himself in at the side door. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was no security guard. Why would there be? "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was nothing worth "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ealing. No burglar worth his salt could be bothered with "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("second")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("hand")]), _vm._v(" o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce equipment. Danny ran "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("light")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("oted")]), _vm._v(" up to the third "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("oor and let himself into Joseph’s o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce. He locked the door behind him and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("arted on the desk drawers. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e top two were unlocked and contained nothing of intere"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" – brochures, a pile of Joseph’s business cards, "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ationery, and the usual muddle of paperclips, ela"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ic bands"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" and pens.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e bottom drawer was locked. Danny sorted through the keys. One of the small ones opened the drawer. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" thing he saw was a sheet of paper with a li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" of names. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e same names he’d seen be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re, with the addition of one other. And what sounded like the runners in the 2.15 at Mu"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("sselburgh.")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_First"
  }, [_vm._v("Graeme Brown – Dec – 125k – Sn"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("agglecat 2")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_Middle"
  }, [_vm._v("Brian McGillivray – Jan – 100k – Meri"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("dian Flyer")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_Middle"
  }, [_vm._v("Wilson Brodie – Feb – 125k – ?Be"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nbecula IV")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1_Last"
  }, [_vm._v("Andrew Mutch – March – 130k – L"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ady Lydnia")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny picked up the paper to photograph its contents with his Kodak In"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("amatic and noticed there was a scribbled note on the o"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ther side.")])]), _vm._v(" "), _c('p', {
    staticClass: "HW1_Handwriting_1"
  }, [_vm._v("Maclays So’ton –Jesper"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("sen Nassau")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He had even less idea what that might mean. But when it came to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rreting out in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rmation, he knew where to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art looking. He glanced back into the drawer and realised there was a metal box under the sheet of paper. He li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("ed it out and sat in on the desk. It was secured with a small but serious lock which yielded to the second key on Jose"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ph’s ring.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ared down at the contents, his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("omach cramping"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" in shock.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8be01c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-11.vue
// module id = 96
// module chunks = 0